import { Close } from '@mui/icons-material';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

export type ChapterCommentPolicyProps = {
    open: boolean;
    onClose: () => void;
};

export default function ChapterCommentPolicy({ open, onClose }: ChapterCommentPolicyProps) {
    return (
        <Dialog
            fullWidth
            open={open}
            onClose={onClose}
            PaperProps={{
                className: 'dark:!bg-[#202020]',
                style: {
                    maxWidth: '480px',
                },
            }}
        >
            <DialogTitle className="flex items-center justify-between py-[20px] pl-[20px] pr-[11px]">
                <span className="text-[21px] font-bold">Comment Policy</span>
                <Close onClick={onClose} className="cursor-pointer text-[#777]" />
            </DialogTitle>
            <DialogContent className="mb-[10px] space-y-[10px] p-[20px] text-[14px] leading-[21px] text-[#666] dark:text-[#BDBDBD]">
                <ol className="list-inside list-decimal mb-24">
                    <PolicyElement>
                        <b>No spoilers.</b> Spoilers constitute any information not available in currently published
                        chapters. Do not hint at future events or confirm/deny speculation.
                    </PolicyElement>
                    <PolicyElement>
                        <b>No insults.</b> Do not be rude or abusive towards any other commenter, translator/editor, or
                        staff member.
                    </PolicyElement>
                    <PolicyElement>
                        <b>No piracy.</b> Do not discuss or advocate for piracy, including posting the name/URL of any
                        piracy source.
                    </PolicyElement>
                    <PolicyElement>
                        <b>No spam.</b> Spamming can include advertising, repeatedly posting the same message, etc.
                    </PolicyElement>
                </ol>
                <p>
                    Rule violations are interpreted at the sole discretion of Wuxiaworld's staff. Breaking rules may
                    result in a temporary or permanent ban from commenting, communicated via the email address
                    associated with the account.
                </p>
                <p>
                    If you think you have found a translation error, please report it in the novel's channel within our{' '}
                    <a
                        href="https://discord.gg/wuxiaworld"
                        target="_blank"
                        rel="noreferrer noopener"
                        className="cursor-pointer underline text-blue"
                    >
                        Discord Server
                    </a>
                    , or{' '}
                    <a
                        href="https://wuxiaworld.atlassian.net/servicedesk/customer/portals"
                        target="_blank"
                        rel="noreferrer noopener"
                        className="cursor-pointer underline text-blue"
                    >
                        open a support ticket
                    </a>
                    .
                </p>
            </DialogContent>
            <DialogActions className="!space-x-[10px] px-[20px] pb-[20px] pt-0">
                <Button
                    className="min-h-[36px] min-w-[94px] !text-[13px] !font-semibold"
                    variant="contained"
                    onClick={onClose}
                >
                    Ok
                </Button>
            </DialogActions>
        </Dialog>
    );
}

function PolicyElement({ children }: { children: React.ReactNode }) {
    return <li className="mb-12">{children}</li>;
}
